import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<Optional<ResponseCategory[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/BaseIngredientCategory/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	return axios.get(url, { params: params }).toOptionalMapped((x) => x.data.categories);
}

interface Parameter {
	SearchTerm: string;
	ShowOnlyDeleted: boolean;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	categories: ResponseCategory[];
};

export type ResponseCategory = {
	id: string;
	description: string;
};
